import decide from './decide.js';
import index from './index';
import { Router } from '@/legacy/Router';
import slideshow from './slideshow.js';

Router.get('qualify/([a-zA-Z]+)/([a-zA-Z]+)', decide);
Router.get('qualify/([a-zA-Z]+)/([a-zA-Z]+)/slideshow', slideshow);
Router.get('qualify', index);
